import { render, staticRenderFns } from "./PTranslation.vue?vue&type=template&id=99d922fc"
import script from "./PTranslation.vue?vue&type=script&lang=js"
export * from "./PTranslation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports